export enum NotificationCode {
  AGENT_REASSIGN = 'AGENT_REASSIGN',
  KAW = 'KAW',
}

export interface NotificationDetail {
  id: string;
  title: string;
  description: string;
  link: string | null;
  read: boolean;
}

export interface AgentReassignNotificationDetail extends NotificationDetail {
  metadata: {
    agents_count: number;
    new_are_name: string;
    old_are_name: string;
    product_type: string;
    new_are_marketing_id: string;
    old_are_marketing_id: string;
  };
}

export interface KawNotificationDetail extends NotificationDetail {
  metadata: {
    data: {
      schedule_id: string;
    };
    status: string;
    message: string;
  };
}

export type Notification = {
  total: number;
  total_unread: number;
  code: NotificationCode;
  details: NotificationDetail[];
} & (
  | {
      code: NotificationCode.AGENT_REASSIGN;
      details: AgentReassignNotificationDetail[];
    }
  | {
      code: NotificationCode.KAW;
      details: KawNotificationDetail[];
    }
);

export interface GetResponseData {
  total: number;
  total_unread: number;
  notifications: Notification[];
}

export interface GetResponse {
  status: string;
  message: string;
  data: GetResponseData;
}

export interface PutResponse {
  data: string;
  status: string;
  message: string;
}
